import React from "react";
import PropTypes from "prop-types";
//
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/styles";
import { createTheme } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const themePalette = createTheme({
  palette: {
    primary: {
      light: "#757ce8",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#fff",
    },
    secondary: {
      light: "#e8e1cc",
      main: "#f5edd5",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      // margin: theme.spacing(1),
    },
  },
  small: {
    // width: theme.spacing(3),
    // height: theme.spacing(3),
  },
  large: {
    // width: theme.spacing(7),
    // height: theme.spacing(7),
  },
  superLarge: {
    // width: theme.spacing(40),
    // height: theme.spacing(40),
    display: "flex",
    justifyContent: "center",
    "& img": {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
}));

export const MESSAGE_TYPE = {
  intro: "intro",
  searching: "searching",
};

const MESSAGE = {
  intro: ["請由上方搜尋框輸入關鍵詞，並篩選搜尋類別，然後啟動搜尋"],
  searching: ["搜尋中..."],
};

const BlankDisplay = (props) => {
  // eslint-disable-next-line no-unused-vars
  const { messageType, searchImage } = props;
  const classes = useStyles();
  //

  return (
    <Container>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item container justifyContent="center">
          <Grid item md={6}>
            <Box mt={4} mb={2} display="flex" justifyContent="center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "300px",
                  height: "300px",
                  borderRadius: "50%",
                  backgroundColor: themePalette.palette.secondary.main,
                }}
              >
                <div className={classes.root}>
                  <Avatar
                    alt="Remy Sharp"
                    src={searchImage}
                    className={classes.superLarge}
                  />
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
        <Grid item container justifyContent="center">
          <Grid item md={6}>
            <Box mt={2} mb={6} textAlign="center">
              {Array.isArray(MESSAGE[messageType]) &&
                MESSAGE[messageType].map((msg) => (
                  <Typography key={uuidv4()} variant="h5">
                    {msg}
                  </Typography>
                ))}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

BlankDisplay.defaultProps = {
  messageType: MESSAGE_TYPE.intro,
  searchImage: undefined,
};

BlankDisplay.propTypes = {
  messageType: PropTypes.string,
  searchImage: PropTypes.string,
};

export default BlankDisplay;
